import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ instructionsArray: string[] }>;

const DispatchSpecialDeliveryInstruction: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/SetSpecialDeliveryInstruction",
        instructionsArray: props.parameter.instructionsArray,
    });
};

export const chain = [DispatchSpecialDeliveryInstruction];

const setInstruction = createHandlerChainRunner(chain, "SpecialDeliveryInstructionHandler");
export default setInstruction;
